import { socketEmit } from 'lib/clients/socket';

export default () => {
  setTimeout(() => {
    socketEmit('list-rooms');
  }, 1000);
};
